<script lang="ts">
  import { fly } from 'svelte/transition';
  import { allClearFlip } from '~/animations.svelte';
  import DailyConfetti from '~/components/DailyConfetti.svelte';
  import Star from '~/icons/Star.svelte';
  import { settings } from '~/modals/Settings.svelte';

  type Props = {
    visible?: boolean;
  };
  const props: Props = $props();
</script>

{#if props.visible}
  {#if settings.confetti.current}
    <DailyConfetti />
  {/if}
  <div class="all-clear" in:fly={{ duration: 250, y: 100 }}>
    <div in:allClearFlip>
      <Star size={96} class="green" />
    </div>
    All Clear Bonus!
  </div>
{/if}

<style lang="scss">
  .all-clear {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1em;
  }
</style>
